/* app/page/homepage */

define( 
	'app/page/homepage',[
		'jquery',
		'pubsub'
	],

	function ($) {

		//member dashboard view all click
		$('.js-dashboard-view-all').on('click', function (event) {
			event.preventDefault();
			var $viewAllLink = $(this);
			var $list = $viewAllLink.closest('.js-dashboard-list');
			if ($list.length) {
				if ($list.hasClass('is-expanded')) {
					$viewAllLink.text('+   View All');
					$list.removeClass('is-expanded');
					setTimeout(function() {
						$list.find('.js-hidden-item').addClass('u-hidden');
					}, 400);
					
				} else {
					
					$viewAllLink.text('-   View Less');
					$list.find('.js-hidden-item').removeClass('u-hidden');
					setTimeout(function () {
						$list.addClass('is-expanded');
						var $images = $list.find('img').filter(function () {
							var $thisImg = $(this);
							return this.src.indexOf($thisImg.attr('data-original')) === -1;
						});
						$.publish('/lazyload/image', [$images]);
					}, 0);
				}
			}
		});

	
	}
);
